import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { RxDotFilled } from 'react-icons/rx';
import c1 from '../assets/c1.png';
import c2 from '../assets/c2.png';
import c3 from '../assets/c3.png';
import c4 from '../assets/c4.png';

const ImageSlider = () => {
  const slides = [
    {
      url: c1,
      title: 'Lobster',
    },
    {
      url: c2,
      title: 'Sushi',
    },
    {
      url: c3,
      title: 'Pasta',
    },
    {
      url: c4,
      title: 'Salmon',
    },
  ];

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <div className='h-[580px] w-full m-auto py-14 relative bg-custom-blue'>
      <Carousel
        responsive={responsive}
        swipeable={true}
        draggable={true}
        showDots={false}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={3000}
        keyBoardControl={true}
        customTransition='transform 300ms ease-in-out'
        transitionDuration={300}
        containerClass='carousel-container'
        removeArrowOnDeviceType={['tablet', 'mobile']}
        dotListClass='custom-dot-list-style'
      >
        {slides.map((slide, index) => (
          <img key={index} src={slide.url} alt={slide.title} className='w-full h-full object-cover rounded-2xl' />
        ))}
      </Carousel>



      <div className='flex justify-center py-2 relative bottom-4 w-full top-2'>
        {slides.map((slide, slideIndex) => (
          <div
            className='text-2xl cursor-pointer mx-2'
            key={slideIndex}
            // onClick={() => goToSlide(slideIndex)} // Se quiser adicionar a funcionalidade de clicar nos pontos para navegar, descomente esta linha
          >
            <RxDotFilled />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;
